











































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { NotificationModule } from '@/app/store/modules/notifications'
import { MasterModule } from '@/app/store/modules/master'
import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  email,
  helpers,
} from 'vuelidate/lib/validators'
import { AdminCMSModule } from '@/app/store/modules/adminCMS'

const salesCheck = (value) => {
  return /^(?=.*[s | S])(?=.*[-])(?=.*[0-9]).{8}$/.test(value)
}

@Component
export default class extends Vue {
  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
  })
  public name: string = ''

  @Validate({
    required,
    minLength: minLength(4),
    email,
  })
  public email: string = ''
  public needSalesCode: boolean = false

  public formatSales = /^(?=.*[s | S])(?=.*[-])(?=.*[0-9]).{8}$/
  @Validate({
    required,
    minLength: minLength(8),
    salesCheck,
  })
  public salesCode: string = ''

  @Validate({
    required,
    minLength: minLength(4),
  })
  public password: string = ''
  public idRole: number = 0
  public role_id: any = [{ value: 0, text: '-Select Role-', salescode: false }]

  public passwordType: string = 'password'
  public iconType: string = 'eye-slash'

  public get listRole() {
    return this.role_id.concat(AdminCMSModule.RoleCMSData)
  }

  public changeRole(e) {
    const selectedRole = this.listRole.find((item) => {
      return item.value === e
    })

    this.needSalesCode = selectedRole.salescode
  }

  public changePasswordType() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text'
      this.iconType = 'eye'
    } else {
      this.passwordType = 'password'
      this.iconType = 'eye-slash'
    }
  }

  // checkbox deletable
  private postData: any = {
    name: '',
    email: '',
    password: '',
    role_id: '',
  }
  public postAdminCMS(item, index, button) {
    this.$v.name.$touch()
    this.$v.email.$touch()
    this.$v.password.$touch()
    this.$v.salesCode.$touch()
    if (
      this.$v.name.$invalid ||
      this.$v.email.$invalid ||
      this.$v.password.$invalid ||
      (this.$v.salesCode.$invalid && this.needSalesCode)
    ) {
      //  console.log('>>>>> data harus diisi <<<<<')
    } else {
      const dataToPost = {
        name: this.name,
        email: this.email,
        password: this.password,
        sales_code: this.salesCode,
        role_id: this.idRole,
      }
      AdminCMSModule.createAdminCMS(dataToPost)
      this.$root.$emit('bv::hide::modal', index, button)
    }
  }

  public resetAdd() {
    this.$v.name.$reset()
    this.$v.email.$reset()
    this.$v.password.$reset()
    this.$v.salesCode.$reset()
    this.needSalesCode = false
    this.name = ''
    this.email = ''
    this.password = ''
    this.salesCode = ''
    this.idRole = 0
  }
}
